import { render, h } from "vue";
import ToasterContainer from "./ToasterContainer.vue";

let mounted = false;

export function mountContainer() {
    if (mounted && document.getElementById("toast-container")) return;

    const el = document.createElement("div");
    el.id = "toast-container";
    document.body.appendChild(el);
    render(h(ToasterContainer), el);
    mounted = true;
}
